import { useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
import { toFormikValidationSchema } from 'zod-formik-adapter';
import useClosable from '../../hooks/useClosable';
import useMarkAsLostValidationSchema from '../../hooks/useMarkAsLostValidationSchema';
import { ClosableOrder } from '../../store/ClosableStore';
import { dealLostReasons } from '../../utils/dealLostReasons';
import commonStyles from "../Common.module.css";
import editStyles from "../Edit.module.css";
import SelectInput from '../inputs/SelectInput';
import TextInput from '../inputs/TextInput';
import Modal from "../Modal";
import Spinner from "../spinners/Spinner";

function MarkAsLostModal({ lostReason, comment, onCancel, onMarkAsLost }: IMarkAsLostModalProps) {
    const validationSchema = useMarkAsLostValidationSchema();

    const formik = useFormik<IMarkAsLostState>({
        initialValues: { lostReason, comment },
        validationSchema: toFormikValidationSchema(validationSchema),
        onSubmit: (values) => onMarkAsLost(values.lostReason!, values.comment),
    });

    const cancel = () => {
        if (!formik.isSubmitting)
            onCancel();
    };

    useClosable(ClosableOrder.High, cancel);

    return (
        <Modal midWidth header="Mark as Lost" onClose={cancel}>
            <div className={editStyles.column}>
                <SelectInput formik={formik} label="LOST REASON" name="lostReason" valueAsCorrectType={value => value}>
                    <option value="">----</option>
                    {dealLostReasons.map(reason => (
                        <option key={reason} value={reason}>{reason}</option>
                    ))}
                </SelectInput>
                <TextInput formik={formik} label="COMMENTS (OPTIONAL)" name="comment" placeholder="Add any additional context..." />
                <div className={commonStyles.controlGroup}>
                    <button className={commonStyles.secondaryButton} disabled={formik.isSubmitting} onClick={cancel}>Cancel</button>
                    {formik.isSubmitting ? (
                        <Spinner />
                    ) : (
                        <button type="submit" className={commonStyles.primaryButton} onClick={() => formik.handleSubmit()}>Mark as Lost</button>
                    )}
                </div>
            </div>
        </Modal>
    );
}

interface IMarkAsLostModalProps {
    lostReason: string | null;
    comment: string | null;
    onCancel: () => void;
    onMarkAsLost: (lostReason: string, comment: string | null) => Promise<void>;
}

export default observer(MarkAsLostModal);

interface IMarkAsLostState {
    lostReason: string | null;
    comment: string | null;
}
